/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * DateTime field representation.
 */
export interface DateTimeClaimValue {
    /** The date-time field value in RFC 3339 format. */
    value: Date;
}
